import { backgroundBlue, black, blue, textMuted } from '@/theme/colors'
import { motion, shadows, layers } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { innerCardSurface, tintOnHover } from '@components/Card'
import styled from 'styled-components'
import { Pill } from '@components/Pill'

/**
 * An event on the board: an inner card that is also the drag handle. The
 * hover tint comes from the recipe; the drag ghost is the one state that
 * casts a shadow, because it floats above the board like an overlay.
 */
export const CardContainer = styled.div<{
	$isDragging?: boolean
	$isOver?: boolean
}>`
	${innerCardSurface}
	${tintOnHover}
	padding: 14px 16px 14px;
	position: relative;
	cursor: grab;
	touch-action: none;
	display: flex;
	flex-direction: column;
	gap: 8px;
	transition:
		background-color ${motion.fast},
		transform ${motion.base};

	${props =>
		props.$isDragging &&
		`
    opacity: 0.5;
    transform: rotate(5deg);
    box-shadow: ${shadows.overlay};
    z-index: ${layers.float};
  `}

	${props =>
		props.$isOver &&
		`
    background: ${backgroundBlue};
    box-shadow: 0 0 0 1px ${blue};
  `}

	&:active {
		cursor: grabbing;
	}
`

export const DraggingPlaceholder = styled.div<{
	$transform?: string
	$transition?: string
}>`
	transform: ${({ $transform }) => $transform};
	transition: ${({ $transition }) => $transition};
	opacity: 0;
	height: 0;
	margin: 0;
	padding: 0;
	overflow: hidden;
`

export const CardHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
`

export const CardTitle = styled.h4`
	${text.label}
	color: ${black};
	margin: 0;
	flex: 1;
	word-break: break-word;
`

export const PillRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	flex-wrap: wrap;
`

export const CategoryPill = styled(Pill)``

export const TimePill = styled(Pill).attrs({ $tone: 'muted' as const })``

export const IconRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	margin-top: 2px;
`

export const IconButton = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 3px;
	color: ${textMuted};
	font-size: ${fontSizes.micro};
	font-weight: 700;
	line-height: ${leading.none};

	svg {
		display: block;
	}
`
